(function () {
  class FreeSpinsIntro extends PIXI.Container {
    constructor() {
      super();
      const self = this;
      this._completeCallback;
      this.visible = false;
      StateMachine.Create(this);
    }

    initialise() {
      this._jsonPath = this.name + ':freeSpinsIntroContainer';
      this._introPanel = undefined;
      this._panelMask = undefined;
      this._skipButton = undefined;
      this._touchToContinue = undefined;

      messageBus.subscribe('spinner:GameConfigEvent', this.onGameConfigEvent.bind(this));
      Reflex.registerEventHandler('orientationChange', () => {
        this.onOrientationChange();
      });
    }

    onOrientationChange() {
      if (this.introMoveTween && this.introMoveTween.isActive()) {
        this.introMoveTween.progress(1);
      }
      if (this.introFadeTween && this.introFadeTween.isActive()) {
        this.introFadeTween.progress(1);
      }
      if (this.outroMoveTween && this.outroMoveTween.isActive()) {
        this.outroMoveTween.progress(1);
      }
      if (this.outroFadeTween && this.outroFadeTween.isActive()) {
        this.outroFadeTween.progress(1);
      }
    }

    onGameConfigEvent(task) {
      // The panels
      // these three are reparented
      this._introPanelGreen = resourceManager.get(this._jsonPath + ':greenPigInfo');
      this._introPanelRed = resourceManager.get(this._jsonPath + ':redPigInfo');
      this._introPanelBlue = resourceManager.get(this._jsonPath + ':bluePigInfo');
      this.removePanels();

      // this one is not
      this._introPanelGold = resourceManager.get(this._jsonPath + ':introPanel:frameGold');

      // Elimination symbols for featureType 3
      this._frameGreen = resourceManager.get(this._jsonPath + ':greenPigInfo:panelContainer:frameGreen');
      this._frameGreenP = resourceManager.get(this._jsonPath + ':greenPigInfo:panelContainer:frameGreenP');

      // Wheel extra pigs text
      this._wheelExtraPigsText = resourceManager.get(this._jsonPath + ':introPanel:frameGold:extraPigs');

      // positional containers
      this._oneFeatureContainer = resourceManager.get(this._jsonPath + ':introPanel:oneFeature');
      this._oneFeatureContainer1 = resourceManager.get(this._jsonPath + ':introPanel:oneFeature:container1');
      this._twoFeaturesContainer = resourceManager.get(this._jsonPath + ':introPanel:twoFeatures');
      this._twoFeaturesContainer1 = resourceManager.get(this._jsonPath + ':introPanel:twoFeatures:container1');
      this._twoFeaturesContainer2 = resourceManager.get(this._jsonPath + ':introPanel:twoFeatures:container2');
      this._threeFeaturesContainer = resourceManager.get(this._jsonPath + ':introPanel:threeFeatures');
      this._threeFeaturesContainer1 = resourceManager.get(this._jsonPath + ':introPanel:threeFeatures:container1');
      this._threeFeaturesContainer2 = resourceManager.get(this._jsonPath + ':introPanel:threeFeatures:container2');
      this._threeFeaturesContainer3 = resourceManager.get(this._jsonPath + ':introPanel:threeFeatures:container3');

      this._panelMask = resourceManager.get(this._jsonPath + ':panelMask');
      this._panelMask.visible = false;

      this._youWonText = resourceManager.get(this._jsonPath + ':introPanel:youWonText');
      this._numFreeSpinsText = resourceManager.get(this._jsonPath + ':introPanel:numFreeSpinsText');

      this._skipButton = resourceManager.get(this._jsonPath + ':panelMask:skipButton');
      this._skipButton.interactive = false;
      this._skipButton.mousedown = this._skipButton.touchstart = this.skipPressed.bind(this);

      this._touchToContinue = resourceManager.get(this._jsonPath + ':introPanel:touchToContinue');
      const isMobile = gdk.deviceInfo.mobile;

      if (isMobile) {
        this._touchToContinue.setTranslationPhrase('t_gcTouchAnywhere');
      } else {
        this._touchToContinue.setTranslationPhrase('t_splashContinue');
      }
    }

    setElimationSymbols(eliminationLevel = 0) {
      // At level -1, nothing eliminated
      // At level 0, tens not symbols visible
      // At level 1, Jack eliminated (index 0)
      // At level 2, Jack & Queen eliminated (indices 0-1)
      // At level 3, Jack, Queen & King eliminated (indices 0-2)
      // At level 4, Jack, Queen, King & Ace eliminated (indices 0-3)
      // At level 5, all symbols eliminated (none visible)

      this._frameGreen.gotoAndStop(eliminationLevel + 1);
      this._frameGreenP.gotoAndStop(eliminationLevel + 1);
    }

    removePanels() {
      if (this._introPanelGreen.parent) {
        this._introPanelGreen.parent.removeChild(this._introPanelGreen);
      }
      if (this._introPanelRed.parent) {
        this._introPanelRed.parent.removeChild(this._introPanelRed);
      }
      if (this._introPanelBlue.parent) {
        this._introPanelBlue.parent.removeChild(this._introPanelBlue);
      }
    }

    /*
      1 = Standard Only,
      2 = Jackpot Only,
      3 = Elimination Only,
      4 = Standard And Jackpot,
      5 = Standard And Elimination,
      6 = Jackpot And Elimination,
      7 = Standard And Jackpot And Elimination
      */
    // get the fetaure panel based on the feature type
    assignAndInitialisePanels(data) {
      this.removePanels();

      this._introPanelGold.renderable = false;

      this._oneFeatureContainer.renderable = false;
      this._twoFeaturesContainer.renderable = false;
      this._threeFeaturesContainer.renderable = false;

      this._youWonText.visible = true;
      this._numFreeSpinsText.visible = true;

      // data.featureType = 6;

      switch (data.featureType) {
        case 1:
          this._yippieSndToUse = 'yippie1';
          this._oneFeatureContainer.renderable = true;
          this.initialiseRedPanel(this._oneFeatureContainer1, data);
          break;
        case 2:
          this._yippieSndToUse = 'yippie1';
          this._oneFeatureContainer.renderable = true;
          this.initialiseBluePanel(this._oneFeatureContainer1, data);
          break;
        case 3:
          this._yippieSndToUse = 'yippie1';
          this._oneFeatureContainer.renderable = true;
          this.initialiseGreenPanel(this._oneFeatureContainer1, data);
          break;
        case 4:
          this._yippieSndToUse = 'yippie2';
          this._twoFeaturesContainer.renderable = true;
          this.initialiseBluePanel(this._twoFeaturesContainer1, data);
          this.initialiseRedPanel(this._twoFeaturesContainer2, data);
          break;
        case 5:
          this._yippieSndToUse = 'yippie2';
          this._twoFeaturesContainer.renderable = true;
          this.initialiseGreenPanel(this._twoFeaturesContainer1, data);
          this.initialiseRedPanel(this._twoFeaturesContainer2, data);
          break;
        case 6:
          this._yippieSndToUse = 'yippie2';
          this._twoFeaturesContainer.renderable = true;
          this.initialiseGreenPanel(this._twoFeaturesContainer1, data);
          this.initialiseBluePanel(this._twoFeaturesContainer2, data);
          break;
        case 7:
          this._yippieSndToUse = 'yippie3';
          this._threeFeaturesContainer.renderable = true;
          this.initialiseGreenPanel(this._threeFeaturesContainer1, data);
          this.initialiseRedPanel(this._threeFeaturesContainer2, data);
          this.initialiseBluePanel(this._threeFeaturesContainer3, data);
          break;
        case 'wheel':
          this._youWonText.visible = false;
          this._numFreeSpinsText.visible = false;
          this._introPanelGold.renderable = true;
          const phrase = data.numUpgrades === 1 ? 't_gcExtraPig' : 't_gcExtraPigs';
          this._wheelExtraPigsText.setTranslationPhrase(phrase);
          this._wheelExtraPigsText.setTranslationParameters(data.numUpgrades);
          break;
      }
    }

    initialiseRedPanel(parent, data) {
      // using data provided, update the required display items
      parent.addChild(this._introPanelRed);
    }

    initialiseBluePanel(parent, data) {
      // using data provided, update the required display items
      parent.addChild(this._introPanelBlue);
    }

    initialiseGreenPanel(parent, data) {
      // using data provided, update the required display items
      this.setElimationSymbols(data.eliminationLevel);
      parent.addChild(this._introPanelGreen);
    }

    startIntro(callback, data) {
      this.visible = true;

      this._numFreeSpinsText.setTranslationParameters(data.spinsAwarded);

      this.assignAndInitialisePanels(data);

      this.wheelIntro = data.featureType === 'wheel';
      musicManager.onFreespinsIntro(this.wheelIntro);

      // hide golden bet button
      resourceManager.get('backgroundButtons:luckyBetToggleButton').visible = false;

      this._completeCallback = callback;
      this._touchToContinue.visible = true;

      this._panelMask.alpha = 0;
      this._panelMask.visible = true;

      const startY = systemData.isLandscape ? 640 : 1280;
      const introPanel = resourceManager.get(this._jsonPath + ':introPanel');
      this.introMoveTween = gsap.fromTo(
        introPanel,
        {
          y: 0 + startY,
        },
        {
          y: 0,
          duration: 0.5,
          ease: 'power1.out',
          onComplete: () => {
            this._skipButton.interactive = true;
            game.autoClickForReplayRewatch(() => {
              this.skipPressed();
            });
          },
        }
      );

      this.introFadeTween = gsap.fromTo(
        [this._panelMask],
        {
          alpha: 0,
        },
        {
          duration: 0.25,
          alpha: 1,
          ease: 'none',
          onComplete: () => {
            if (!this.wheelIntro) {
              resourceManager.get('gameBackground:GameBackground').setHueToPerc(1);
            }
          },
        }
      );
    }

    endIntro() {
      this._touchToContinue.visible = false;

      if (musicManager.fsIntroTimer != null) {
        timerManager.stop(musicManager.fsIntroTimer);
        musicManager.fsIntroTimer = null;

        if (this.wheelIntro === true) {
          musicManager.playWheelTune();
        } else {
          musicManager.onFreeSpinsStart();
        }
      }

      const endY = systemData.isLandscape ? 640 : 1280;
      const introPanel = resourceManager.get(this._jsonPath + ':introPanel');
      this.outroMoveTween = gsap.fromTo(
        introPanel,
        {
          y: 0,
        },
        {
          y: 0 + endY,
          duration: 0.5,
          ease: 'power1.in',
          onComplete: () => {
            this._completeCallback();
          },
        }
      );

      this.outroFadeTween = gsap.fromTo(
        [this._panelMask],
        {
          alpha: 1,
        },
        {
          delay: 0.25,
          duration: 0.25,
          alpha: 0,
          ease: 'none',
          onComplete: () => {
            this._panelMask.visible = false;
            this.visible = false;
          },
        }
      );
    }

    skipPressed() {
      soundManager.play(this._yippieSndToUse);
      game.stopAutoClickForReplayRewatch();
      this._skipButton.interactive = false;
      this.endIntro();
    }
  }

  create = function (json) {
    return new FreeSpinsIntro();
  };

  getFilesRequired = function (json) {
    return [];
  };

  resourceManager.registerObjectType('freeSpinsIntro', create, initialise, getFilesRequired);
})();
